import Vue from 'vue'
import App from './App.vue'
import {router} from './router'
import VueClipboard from 'vue-clipboard2'

// normalize 样式初始化
import 'normalize.css/normalize.css'
//引入vuex
import {store} from "./store"

Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;

Vue.use(VueClipboard);

//全局过滤器
Vue.filter('formatCreatetime', function (value) {
  if (!value) return ''
  value = value.toString();
  let year,mon,day,hour,min,sec;
  year=value.slice(0,4);
  mon=value.slice(4,6);
  day=value.slice(6,8);
  hour=value.slice(8,10);
  min=value.slice(10,12);
  sec=value.slice(12);
  return `${year}-${mon}-${day} ${hour}:${min}:${sec}`
})
Vue.filter('createtimeNotime', function (value) {
  if (!value) return ''
  value = value.toString();
  let year,mon,day;
  year=value.slice(0,4);
  mon=value.slice(4,6);
  day=value.slice(6,8);
  return `${year}-${mon}-${day}`
})


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
